import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { getUser } from '../../utils'

import { SidebarData, SidebarDataProps } from './sidebar-data'
import SidebarItem from './sidebar-item'

import * as S from './styles'
function Navbar() {
  const [sidebar, setSidebar] = useState(false)
  const navigate = useLocation()
  const showSidebar = () => setSidebar(!sidebar)

  const user = getUser()
  const clickOutside = (event: React.FormEvent) => {
    if (event.target === event.currentTarget) {
      setSidebar(false)
    }
  }

  useEffect(() => {
    setSidebar(false)
  }, [navigate.pathname])

  return (
    <S.Wrapper className="no-print">
      <Link to="#" className="menu-bars" onClick={showSidebar}>
        <button className="menu" aria-label="menu" />
      </Link>
      {sidebar ? (
        <div className="overlay" onClick={clickOutside}>
          <div className={sidebar ? 'nav-menu active' : 'nav-menu'}>
            {SidebarData().map((item: SidebarDataProps) => {
              if (user) {
                if (
                  (item.allowed === '1' &&
                    user.usuario.roles[0].cdRole === 1) ||
                  item.allowed === '2'
                )
                  return (
                    <SidebarItem
                      key={item.title}
                      sidebar={sidebar}
                      item={item}
                    />
                  )
                else {
                  return null
                }
              }
              return null
            })}
          </div>
        </div>
      ) : (
        <div
          onClick={showSidebar}
          className={sidebar ? 'nav-menu active' : 'nav-menu'}
        >
          {SidebarData().map((item: SidebarDataProps) => {
            if (user) {
              if (
                (item.allowed === '1' && user.usuario.roles[0].cdRole === 1) ||
                item.allowed === '2'
              )
                return (
                  <SidebarItem key={item.title} sidebar={sidebar} item={item} />
                )
              else {
                return null
              }
            }
            return null
          })}
        </div>
      )}
    </S.Wrapper>
  )
}

export default Navbar
